package uz.ferro.shop.pages.about

import kotlinx.serialization.Serializable
import uz.ferro.shop.document.FormattedDictText
import uz.ferro.shop.model.DictItem

@Serializable
data class PageContentItem(
    val title: DictItem? = null,
    val description: DictItem? = null,
    val formattedDescription: FormattedDictText? = null,
    val image: String? = null,
    val items: List<PageContentItem>? = null,
    val link: String? = null
)
